/* ============================================================================
 * sp-configurador.js — Sportiva .925
 * ----------------------------------------------------------------------------
 * Configurador de piezas grabadas.
 *
 * LO QUE ARMA
 *   1. Elegir la pieza (ocho charms o el dije).
 *   2. Si la pieza tiene opciones (el dije tiene Material y Forma), elegirlas.
 *   3. Llenar las caras: texto o figura.
 *   4. Solo en el dije: hilo de color, cadena, o nada.
 *
 * TRES LÍNEAS DISTINTAS EN EL CARRITO
 *   La pieza, el grabado y la cadena entran como artículos separados: el
 *   grabado es un cargo único que el taller puede resubir sin tocar el precio
 *   de cada forma, y la cadena tiene su propio inventario. Se unen con la
 *   propiedad oculta _grupo para que en el pedido se lea como una sola pieza.
 *
 * REGLAS DE NEGOCIO QUE VIVEN AQUÍ
 *   · El grabado cuesta lo mismo sin importar cuántas caras se graben.
 *   · Una cara grabada lleva texto O figura, nunca las dos: la superficie es
 *     de centímetros y una se comería a la otra.
 *   · La forma "Texto" es la excepción, y no por capricho: ahí el nombre y la
 *     figura se cortan de la MISMA lámina y quedan pegados. Por eso conviven,
 *     la figura va sin costo, y el cliente elige de qué lado la quiere.
 *   · Un nombre calado NO admite espacios: la pieza se corta entera, y un
 *     espacio la partiría en dos trozos sueltos.
 *   · La cadena siempre es del mismo material que el dije.
 *   · El hilo no cuesta.
 *
 * EL ACABADO NO SE DIBUJA AQUÍ
 *   Este archivo no sabe de qué color es el oro ni de qué lado entra el
 *   traslape. Solo pone data-metal y una clase en la placa; la hoja de la
 *   sección resuelve el resto.
 * ========================================================================== */

(function () {
  'use strict';

  /* Grabar admite espacio: una incisión sobre una placa puede llevar dos
     palabras sin que la placa deje de ser una sola pieza. */
  var CHARSET = /[^A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ .&'-]/g;

  /* Calar no: el espacio desprende. Mismo juego, sin el espacio. */
  var CHARSET_RECORTE = /[^A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ.&'-]/g;

  var LADOS = [
    { id: 'izq', txt: 'A la izquierda', palabra: 'a la izquierda del nombre' },
    { id: 'der', txt: 'A la derecha',   palabra: 'a la derecha del nombre' }
  ];

  function ladoPorId(id) {
    return LADOS.filter(function (l) { return l.id === id; })[0] || LADOS[0];
  }

  function etiquetasDeCaras(n) {
    if (n <= 1) return ['Grabado'];
    if (n === 2) return ['Frente', 'Reverso'];
    var out = [];
    for (var i = 1; i <= n; i++) out.push('Cara ' + i);
    return out;
  }

  function el(tag, attrs, hijos) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (attrs[k] !== null && attrs[k] !== undefined) n.setAttribute(k, attrs[k]);
    });
    (hijos || []).forEach(function (h) { if (h) n.appendChild(h); });
    return n;
  }

  /* La silueta se aplica como máscara, no como imagen: el relleno lo pone el
     CSS según el material. Es lo que permite que la misma figura salga
     grabada en gris sobre plata y calada en oro sin dos archivos. */
  function enmascarar(nodo, src) {
    var v = 'url("' + src + '")';
    nodo.style.webkitMaskImage = v;
    nodo.style.maskImage = v;
  }

  /* Y la caja tiene que medir exactamente lo que mide la silueta. Si se queda
     cuadrada, a una figura vertical —la bailarina, por ejemplo— le sobra aire
     por los lados, y ese aire se ve como una separación entre la figura y la
     letra: justo lo que en la pieza real no existe, porque las dos salen de la
     misma lámina. La proporción se lee del archivo en vez de guardarse a mano,
     así sigue funcionando con cualquier figura que se suba después. */
  var proporciones = {};
  function ajustarProporcion(nodo, src) {
    if (proporciones[src]) { nodo.style.aspectRatio = proporciones[src]; return; }
    var im = new Image();
    im.onload = function () {
      if (!im.naturalWidth || !im.naturalHeight) return;
      proporciones[src] = im.naturalWidth + ' / ' + im.naturalHeight;
      nodo.style.aspectRatio = proporciones[src];
    };
    im.src = src;
  }

  function vestirFigura(nodo, src) {
    enmascarar(nodo, src);
    ajustarProporcion(nodo, src);
  }

  function dinero(centavos, plantilla) {
    var n = (centavos / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (plantilla || '$ {{amount}}').replace('{{amount}}', n);
  }

  function Configurador(raiz) {
    this.raiz      = raiz;
    this.piezas    = this.leerJSON('[data-sp-cfg-piezas]') || [];
    this.imagenes  = this.leerJSON('[data-sp-cfg-imagenes]') || [];
    this.hilos     = this.leerJSON('[data-sp-cfg-hilos]') || [];
    this.grabado   = this.leerJSON('[data-sp-cfg-grabado]');
    this.cadena    = this.leerJSON('[data-sp-cfg-cadena]');
    this.formato   = raiz.getAttribute('data-money') || '$ {{amount}}';

    this.pieza = null;
    this.opciones = {};
    this.caras = [];
    this.cordon = 'ninguno';
    this.hilo = null;
    this.caraActiva = null;
    /* Izquierda por defecto porque es como está la pieza de muestra. */
    this.lado = 'izq';

    this.elGrid     = raiz.querySelector('[data-sp-cfg-grid]');
    this.elPaso1    = raiz.querySelector('[data-sp-cfg-paso="1"]');
    this.elPaso2    = raiz.querySelector('[data-sp-cfg-paso="2"]');
    this.elOpciones = raiz.querySelector('[data-sp-cfg-opciones]');
    this.elCaras    = raiz.querySelector('[data-sp-cfg-caras]');
    this.elCordon   = raiz.querySelector('[data-sp-cfg-cordon]');
    this.elTitulo   = raiz.querySelector('[data-sp-cfg-titulo]');
    this.elResumen  = raiz.querySelector('[data-sp-cfg-resumen]');
    this.elTotal    = raiz.querySelector('[data-sp-cfg-total]');
    this.elAgregar  = raiz.querySelector('[data-sp-cfg-agregar]');
    this.elAviso    = raiz.querySelector('[data-sp-cfg-aviso]');
    this.elVolver   = raiz.querySelector('[data-sp-cfg-volver]');
    this.elModal    = raiz.querySelector('[data-sp-cfg-modal]');
    this.elGaleria  = raiz.querySelector('[data-sp-cfg-galeria]');

    this.pintarGrid();
    this.enlazar();
  }

  Configurador.prototype.leerJSON = function (sel) {
    var n = this.raiz.querySelector(sel);
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  };

  /* --------------------------------------------------------------- helpers */

  Configurador.prototype.esTexto = function () {
    return this.opciones['Forma'] === 'Texto';
  };

  Configurador.prototype.variante = function () {
    var self = this;
    if (!this.pieza) return null;
    if (!this.pieza.opciones.length) return this.pieza.variantes[0];
    return this.pieza.variantes.filter(function (v) {
      return self.pieza.opciones.every(function (o, i) { return v.opciones[i] === self.opciones[o.nombre]; });
    })[0] || null;
  };

  Configurador.prototype.cadenasCompatibles = function () {
    var mat = this.opciones['Material'];
    if (!this.cadena || !mat) return [];
    return this.cadena.variantes.filter(function (v) { return v.material === mat && v.disponible; });
  };

  Configurador.prototype.hayGrabado = function () {
    /* En el nombre calado no hay grabado que cobrar: ni el texto ni la figura
       son incisiones, las dos son plata cortada. */
    if (this.esTexto()) return false;
    return this.caras.some(function (c) { return c.texto.trim() || c.imagen; });
  };

  /* Cada repintado vuelve a decidir el acabado, porque el material puede
     haber cambiado desde el anterior. */
  Configurador.prototype.fijarMetal = function () {
    var mat = this.opciones['Material'] || '';
    this.raiz.setAttribute('data-metal', /dorado|oro/i.test(mat) ? 'oro' : 'plata');
  };

  /* ---------------------------------------------------------------- paso 1 */

  Configurador.prototype.pintarGrid = function () {
    var self = this;
    this.elGrid.innerHTML = '';

    this.piezas.forEach(function (p) {
      var medio = p.img
        ? el('img', { class: 'sp-cfg__card-img', src: p.img, alt: '', loading: 'lazy', width: '160', height: '160' })
        : el('span', { class: 'sp-cfg__card-ph', 'aria-hidden': 'true' });

      var card = el('button', { class: 'sp-cfg__card', type: 'button', 'data-forma': p.forma }, [
        medio,
        el('span', { class: 'sp-cfg__card-nombre', text: p.titulo }),
        el('span', { class: 'sp-cfg__card-caras', text: p.caras === 1 ? 'grabado a elegir' : p.caras + ' caras grabables' }),
        el('span', { class: 'sp-cfg__card-precio', text: (p.opciones.length ? 'desde ' : '') + dinero(p.desde, self.formato) })
      ]);

      card.addEventListener('click', function () { self.elegir(p); });
      self.elGrid.appendChild(card);
    });
  };

  /* ---------------------------------------------------------------- paso 2 */

  Configurador.prototype.elegir = function (p) {
    var self = this;
    this.pieza = p;
    this.opciones = {};
    p.opciones.forEach(function (o) { self.opciones[o.nombre] = o.valores[0]; });

    this.caras = [];
    for (var i = 0; i < p.caras; i++) this.caras.push({ texto: '', imagen: null });
    this.cordon = 'ninguno';
    this.hilo = null;
    this.lado = 'izq';

    this.elTitulo.textContent = p.titulo;
    this.pintarOpciones();
    this.pintarCaras();
    this.pintarCordon();
    this.revisar();

    this.elPaso1.hidden = true;
    this.elPaso2.hidden = false;
    this.elPaso2.focus();
    this.elPaso2.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  Configurador.prototype.pintarOpciones = function () {
    var self = this;
    this.elOpciones.innerHTML = '';
    if (!this.pieza.opciones.length) { this.elOpciones.hidden = true; return; }
    this.elOpciones.hidden = false;

    this.pieza.opciones.forEach(function (o) {
      var fila = el('div', { class: 'sp-cfg__opcion' }, [
        el('span', { class: 'sp-cfg__opcion-etq', text: o.nombre })
      ]);
      var grupo = el('div', { class: 'sp-cfg__pills', role: 'radiogroup', 'aria-label': o.nombre });

      o.valores.forEach(function (val) {
        var b = el('button', {
          class: 'sp-cfg__pill' + (self.opciones[o.nombre] === val ? ' sp-cfg__pill--on' : ''),
          type: 'button',
          'aria-pressed': self.opciones[o.nombre] === val ? 'true' : 'false',
          text: val
        });
        b.addEventListener('click', function () {
          self.opciones[o.nombre] = val;
          if (self.cordon === 'cadena' && !self.cadenasCompatibles().length) self.cordon = 'ninguno';
          self.fijarMetal();
          self.pintarOpciones();
          self.pintarCaras();
          self.pintarCordon();
          self.revisar();
        });
        grupo.appendChild(b);
      });

      fila.appendChild(grupo);
      self.elOpciones.appendChild(fila);
    });
  };

  Configurador.prototype.pintarCaras = function () {
    var self = this;
    var texto = this.esTexto();
    var filtro = texto ? CHARSET_RECORTE : CHARSET;
    var etiquetas = texto ? ['Nombre'] : etiquetasDeCaras(this.pieza.caras);
    var max = this.pieza.max;
    var hayLibreria = this.imagenes.length > 0;

    this.elCaras.innerHTML = '';
    this.fijarMetal();

    /* Las caras viven en una rejilla, así que una explicación suelta se
       acomodaría como si fuera una cara más. Ocupa la fila entera. */
    function explicar(txt) {
      self.elCaras.appendChild(el('p', {
        class: 'sp-cfg__explica', style: 'grid-column: 1 / -1;', text: txt
      }));
    }

    if (texto) {
      explicar('El nombre se cala en plata y es la pieza misma, no un grabado. Por eso no lleva cargo de grabado, y por eso va en una sola palabra: un espacio partiría el dije en dos trozos sueltos. Puedes acompañarlo con una figura, que se corta pegada al nombre en la misma lámina y va sin costo.');
    } else if (hayLibreria) {
      explicar('Cada cara lleva texto o figura, no las dos: la superficie es de centímetros y una se comería a la otra.');
    }

    etiquetas.forEach(function (etq, i) {
      var estado = self.caras[i] || (self.caras[i] = { texto: '', imagen: null });

      /* Un grabado se lee mejor en versalitas; un dije de nombre se corta en
         script conectada y va en capitalización normal. El teclado del
         teléfono tiene que acompañar esa diferencia. */
      var campo = el('input', {
        class: 'sp-cfg__campo', type: 'text', id: 'sp-cfg-cara-' + i,
        maxlength: String(max), autocomplete: 'off',
        autocapitalize: texto ? 'words' : 'characters',
        spellcheck: 'false', placeholder: texto ? 'Ej. Vicky' : 'Texto de esta cara'
      });
      campo.value = estado.texto;

      var cuenta = el('span', { class: 'sp-cfg__cuenta', 'aria-live': 'polite' });
      var nota = el('span', {
        class: 'sp-cfg__cuenta', 'aria-live': 'polite',
        style: 'display: block; margin-top: 0.4rem; color: var(--sp-alerta);'
      });

      var previa = el('span', { class: 'sp-cfg__previa-txt' });
      var figura = el('span', { class: 'sp-cfg__figura', 'aria-hidden': 'true' });
      figura.hidden = !estado.imagen;
      if (estado.imagen) vestirFigura(figura, estado.imagen.src);

      var btnImg = el('button', {
        class: 'sp-cfg__btn-img', type: 'button',
        text: (estado.imagen ? 'Cambiar ' : 'Agregar ') + 'figura'
      });
      var quitaImg = el('button', { class: 'sp-cfg__quita-img', type: 'button', text: 'Quitar figura' });
      quitaImg.hidden = !estado.imagen;

      /* El lado solo existe donde la figura comparte lámina con el nombre, y
         solo tiene sentido cuando ya hay figura elegida. */
      var bloqueLado = null;
      if (texto) {
        var pills = el('div', { class: 'sp-cfg__pills', role: 'radiogroup', 'aria-label': 'Lado de la figura' });
        LADOS.forEach(function (l) {
          var b = el('button', {
            class: 'sp-cfg__pill' + (self.lado === l.id ? ' sp-cfg__pill--on' : ''),
            type: 'button',
            'aria-pressed': self.lado === l.id ? 'true' : 'false',
            text: l.txt
          });
          b.addEventListener('click', function () {
            self.lado = l.id;
            self.pintarCaras();
            self.revisar();
          });
          pills.appendChild(b);
        });
        bloqueLado = el('div', { class: 'sp-cfg__lado' }, [
          el('span', { class: 'sp-cfg__opcion-etq', text: 'Dónde va la figura' }),
          pills
        ]);
        bloqueLado.hidden = !estado.imagen;
      }

      /* La exclusiva es solo del grabado. En el dije de nombre el texto y la
         figura son partes de la misma pieza y conviven. */
      function exclusiva() {
        if (texto) return;
        campo.disabled = !!estado.imagen;
        btnImg.disabled = estado.texto.length > 0;
      }

      function refrescar(porEscrito) {
        var bruto = campo.value;
        var limpio = bruto.replace(filtro, '').slice(0, max);
        if (limpio !== bruto) {
          var pos = campo.selectionStart - (bruto.length - limpio.length);
          campo.value = limpio;
          try { campo.setSelectionRange(pos, pos); } catch (e) {}
        }
        estado.texto = limpio;
        previa.textContent = limpio;

        /* El fantasma "Su texto" anuncia un hueco que se puede llenar. En una
           cara grabada que ya tiene figura ese hueco no existe —texto y figura
           se excluyen— así que ahí no anuncia nada: solo aparece un letrero
           junto al dibujo como si faltara algo. Se esconde la previa entera,
           no solo el texto, para que la figura quede centrada en la placa en
           vez de correrse por el espacio que dejaría un span vacío.

           En el dije de nombre sí se queda: ahí el nombre es obligatorio y el
           fantasma es justamente lo que avisa que falta. */
        var vacio = limpio.length === 0;
        var soloFigura = vacio && !!estado.imagen && !texto;
        previa.hidden = soloFigura;
        previa.classList.toggle('sp-cfg__previa-txt--vacio', vacio && !soloFigura);

        var quedan = max - limpio.length;
        cuenta.textContent = quedan === 1 ? '1 carácter disponible' : quedan + ' caracteres disponibles';

        /* Un control apagado sin explicación se lee como una página rota, así
           que el motivo aparece justo debajo del control. */
        if (texto && porEscrito && /\s/.test(bruto)) {
          nota.textContent = 'Sin espacios: el nombre se cala en una sola pieza.';
        } else if (!texto && estado.imagen) {
          nota.textContent = 'Esta cara lleva figura. Quítala para escribir texto.';
        } else if (!texto && hayLibreria && limpio.length) {
          nota.textContent = 'Esta cara ya lleva texto. Bórralo para poner figura.';
        } else {
          nota.textContent = '';
        }

        exclusiva();
        self.revisar();
      }
      campo.addEventListener('input', function () { refrescar(true); });

      btnImg.addEventListener('click', function () { self.abrirGaleria(i); });
      quitaImg.addEventListener('click', function () {
        estado.imagen = null; self.pintarCaras(); self.revisar();
      });

      /* Sin librería cargada no hay nada que elegir. */
      if (!hayLibreria) { btnImg.hidden = true; quitaImg.hidden = true; }

      var clasePlaca = 'sp-cfg__placa';
      if (texto) {
        clasePlaca += ' sp-cfg__placa--recorte';
        if (self.lado === 'der') clasePlaca += ' sp-cfg__placa--figura-dcha';
      }

      self.elCaras.appendChild(el('fieldset', { class: 'sp-cfg__cara' + (texto ? ' sp-cfg__cara--recorte' : '') }, [
        el('legend', { class: 'sp-cfg__cara-etq', text: etq }),
        el('div', { class: clasePlaca }, [figura, previa]),
        el('label', { class: 'sp-cfg__label', for: 'sp-cfg-cara-' + i, text: texto ? 'Nombre a calar · una sola palabra' : 'Texto' }),
        campo,
        el('p', { class: 'sp-cfg__pie' }, [cuenta, nota]),
        el('div', { class: 'sp-cfg__acciones-img' }, [btnImg, quitaImg]),
        bloqueLado
      ]));
      refrescar(false);
    });
  };

  /* --------------------------------------------------------------- cordón */

  Configurador.prototype.pintarCordon = function () {
    var self = this;
    this.elCordon.innerHTML = '';

    if (this.pieza.forma !== 'dije') { this.elCordon.hidden = true; return; }
    this.elCordon.hidden = false;

    var compatibles = this.cadenasCompatibles();

    this.elCordon.appendChild(el('h4', { class: 'sp-cfg__sub', text: '¿Cómo lo quieres colgar?' }));
    this.elCordon.appendChild(el('p', { class: 'sp-cfg__explica', text: 'Opcional: puedes llevarte solo el dije.' }));

    var pills = el('div', { class: 'sp-cfg__pills', role: 'radiogroup', 'aria-label': 'Cordón' });

    var opts = [
      { id: 'ninguno', txt: 'Solo el dije' },
      { id: 'hilo', txt: 'Con hilo · sin costo' }
    ];
    if (compatibles.length) {
      opts.push({ id: 'cadena', txt: 'Con cadena · desde ' + dinero(Math.min.apply(null, compatibles.map(function (v) { return v.precio; })), this.formato) });
    }

    opts.forEach(function (o) {
      var b = el('button', {
        class: 'sp-cfg__pill' + (self.cordon === o.id ? ' sp-cfg__pill--on' : ''),
        type: 'button', 'aria-pressed': self.cordon === o.id ? 'true' : 'false', text: o.txt
      });
      b.addEventListener('click', function () {
        self.cordon = o.id;
        if (o.id === 'hilo' && !self.hilo) self.hilo = self.hilos[0] || null;
        if (o.id === 'cadena') self.cadenaElegida = compatibles[0] || null;
        self.pintarCordon(); self.revisar();
      });
      pills.appendChild(b);
    });
    this.elCordon.appendChild(pills);

    if (this.cordon === 'hilo' && this.hilos.length) {
      var muestras = el('div', { class: 'sp-cfg__hilos', role: 'radiogroup', 'aria-label': 'Color de hilo' });
      this.hilos.forEach(function (h) {
        var b = el('button', {
          class: 'sp-cfg__hilo' + (self.hilo && self.hilo.id === h.id ? ' sp-cfg__hilo--on' : ''),
          type: 'button', title: h.nombre, 'aria-label': h.nombre,
          'aria-pressed': self.hilo && self.hilo.id === h.id ? 'true' : 'false',
          style: '--sp-hilo: ' + h.color
        });
        b.addEventListener('click', function () { self.hilo = h; self.pintarCordon(); self.revisar(); });
        muestras.appendChild(b);
      });
      this.elCordon.appendChild(muestras);
      this.elCordon.appendChild(el('p', { class: 'sp-cfg__hilo-nombre', text: this.hilo ? this.hilo.nombre : '' }));
    }

    if (this.cordon === 'cadena' && compatibles.length > 1) {
      var largos = el('div', { class: 'sp-cfg__pills', role: 'radiogroup', 'aria-label': 'Largo de cadena' });
      compatibles.forEach(function (v) {
        var b = el('button', {
          class: 'sp-cfg__pill' + (self.cadenaElegida && self.cadenaElegida.id === v.id ? ' sp-cfg__pill--on' : ''),
          type: 'button', text: v.largo + ' · ' + dinero(v.precio, self.formato)
        });
        b.addEventListener('click', function () { self.cadenaElegida = v; self.pintarCordon(); self.revisar(); });
        largos.appendChild(b);
      });
      this.elCordon.appendChild(largos);
    }
  };

  /* -------------------------------------------------------------- galería */

  Configurador.prototype.abrirGaleria = function (indice) {
    var self = this;
    this.caraActiva = indice;
    this.elGaleria.innerHTML = '';

    var porCategoria = {};
    this.imagenes.forEach(function (img) {
      var c = img.categoria || 'General';
      (porCategoria[c] = porCategoria[c] || []).push(img);
    });

    /* Sin sort alfabético: las categorías salen en el orden en que aparecieron
       en la librería, que ya viene ordenada por el campo "orden" del
       metaobjeto. Ordenarlas por alfabeto pondría "Balones" antes que
       gimnasia, que es justo al revés de lo que vende esta marca. */
    Object.keys(porCategoria).forEach(function (cat) {
      self.elGaleria.appendChild(el('h4', { class: 'sp-cfg__gal-cat', text: cat }));
      var fila = el('div', { class: 'sp-cfg__gal-fila' });
      porCategoria[cat].forEach(function (img) {
        /* También aquí la figura sale del metal elegido: se escoge viendo cómo
           va a quedar, no un dibujo negro que después cambia. */
        var muestra = el('span', { class: 'sp-cfg__gal-fig', 'aria-hidden': 'true' });
        enmascarar(muestra, img.src);

        var b = el('button', { class: 'sp-cfg__gal-item', type: 'button' }, [
          muestra, el('span', { text: img.nombre })
        ]);
        b.addEventListener('click', function () {
          var cara = self.caras[self.caraActiva];
          cara.imagen = img;
          /* Poner figura en una cara grabada desaloja el texto: son
             excluyentes, y dejarlo guardado en silencio haría que reapareciera
             al quitar la figura sin que nadie lo pidiera. */
          if (!self.esTexto()) cara.texto = '';
          self.cerrarGaleria(); self.pintarCaras(); self.revisar();
        });
        fila.appendChild(b);
      });
      self.elGaleria.appendChild(fila);
    });

    this.elModal.hidden = false;
    this.elModal.querySelector('[data-sp-cfg-cerrar]').focus();
  };

  Configurador.prototype.cerrarGaleria = function () {
    this.elModal.hidden = true;
    this.caraActiva = null;
  };

  /* ------------------------------------------------------ resumen y total */

  Configurador.prototype.revisar = function () {
    var v = this.variante();
    var lineas = [];
    var total = 0;
    var falta = '';

    if (!v) {
      falta = 'Esa combinación no está disponible.';
    } else {
      lineas.push({ txt: this.pieza.titulo + (this.pieza.opciones.length ? ' · ' + v.opciones.join(' · ') : ''), precio: v.precio });
      total += v.precio;

      if (this.hayGrabado() && this.grabado) {
        lineas.push({ txt: 'Grabado', precio: this.grabado.precio });
        total += this.grabado.precio;
      }
      /* La figura calada aparece en el desglose aunque no cobre: que se vea
         en cero, y de qué lado va, es parte de lo que se está comprando. */
      if (this.esTexto() && this.caras[0] && this.caras[0].imagen) {
        lineas.push({
          txt: 'Figura ' + this.caras[0].imagen.nombre + ' · ' + ladoPorId(this.lado).palabra,
          precio: 0
        });
      }
      if (this.cordon === 'hilo' && this.hilo) {
        lineas.push({ txt: 'Hilo ' + this.hilo.nombre, precio: 0 });
      }
      if (this.cordon === 'cadena' && this.cadenaElegida) {
        lineas.push({ txt: 'Cadena' + (this.cadenaElegida.largo ? ' ' + this.cadenaElegida.largo : ''), precio: this.cadenaElegida.precio });
        total += this.cadenaElegida.precio;
      }

      if (this.esTexto() && !this.caras[0].texto.trim()) falta = 'Escribe el nombre que quieres calar.';
    }

    this.elResumen.innerHTML = '';
    lineas.forEach(function (l) {
      this.elResumen.appendChild(el('li', { class: 'sp-cfg__linea' }, [
        el('span', { text: l.txt }),
        el('span', { class: 'sp-cfg__linea-precio', text: l.precio ? dinero(l.precio, this.formato) : 'sin costo' })
      ]));
    }, this);

    this.elTotal.textContent = dinero(total, this.formato);
    this.elAgregar.disabled = !!falta || !v;
    this.elAviso.textContent = falta;
    this.elAviso.classList.toggle('sp-cfg__aviso--activo', !!falta);
  };

  /* -------------------------------------------------------------- carrito */

  Configurador.prototype.agregar = function () {
    var self = this;
    var v = this.variante();
    if (!v) return;

    var texto = this.esTexto();
    var grupo = 'sp-' + Date.now().toString(36);
    var etiquetas = texto ? ['Nombre'] : etiquetasDeCaras(this.pieza.caras);
    var props = { '_grupo': grupo, '_forma': this.pieza.forma };
    var idsImagen = [];

    this.caras.forEach(function (c, i) {
      if (i >= etiquetas.length) return;

      /* En el dije de nombre la figura es parte de la misma lámina, pero es un
         corte distinto: en el taller se lee "Nombre: Vicky" y "Figura: Salto
         de gimnasia · a la izquierda del nombre". El lado va en la misma línea
         porque sin él la plantilla no se puede trazar. */
      if (texto) {
        if (c.texto.trim()) props['Nombre'] = c.texto.trim();
        if (c.imagen) {
          props['Figura'] = c.imagen.nombre + ' · ' + ladoPorId(self.lado).palabra;
          props['_lado'] = self.lado;
          idsImagen.push('Figura=' + c.imagen.id);
        }
        return;
      }

      /* En una cara grabada solo puede haber una de las dos. */
      if (c.imagen) { props[etiquetas[i]] = 'figura: ' + c.imagen.nombre; idsImagen.push(etiquetas[i] + '=' + c.imagen.id); }
      else if (c.texto.trim()) { props[etiquetas[i]] = c.texto.trim(); }
    });
    if (idsImagen.length) props['_imagenes'] = idsImagen.join(' | ');

    if (this.cordon === 'hilo' && this.hilo) props['Hilo'] = this.hilo.nombre;
    if (this.cordon === 'ninguno') props['Cordón'] = 'Sin hilo ni cadena';

    var items = [{ id: v.id, quantity: 1, properties: props }];

    if (this.hayGrabado() && this.grabado) {
      items.push({ id: this.grabado.variant, quantity: 1, properties: { '_grupo': grupo, 'Para': this.pieza.titulo } });
    }
    if (this.cordon === 'cadena' && this.cadenaElegida) {
      items.push({ id: this.cadenaElegida.id, quantity: 1, properties: { '_grupo': grupo, 'Para': this.pieza.titulo } });
    }

    this.elAgregar.disabled = true;
    this.elAgregar.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'No se pudo agregar');
        window.location.href = '/cart';
      })
      .catch(function (err) {
        self.elAgregar.disabled = false;
        self.elAgregar.textContent = 'Agregar al carrito';
        self.elAviso.textContent = 'No se pudo agregar: ' + err.message;
        self.elAviso.classList.add('sp-cfg__aviso--activo');
      });
  };

  /* --------------------------------------------------------------- eventos */

  Configurador.prototype.enlazar = function () {
    var self = this;

    this.elVolver.addEventListener('click', function () {
      self.elPaso2.hidden = true;
      self.elPaso1.hidden = false;
      self.elPaso1.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    this.elAgregar.addEventListener('click', function () { self.agregar(); });
    this.elModal.querySelector('[data-sp-cfg-cerrar]').addEventListener('click', function () { self.cerrarGaleria(); });
    this.elModal.addEventListener('click', function (e) { if (e.target === self.elModal) self.cerrarGaleria(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.elModal.hidden) self.cerrarGaleria();
    });
  };

  function iniciar() {
    document.querySelectorAll('[data-sp-configurador]').forEach(function (n) {
      if (!n.__spCfg) n.__spCfg = new Configurador(n);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  document.addEventListener('shopify:section:load', iniciar);
})();